export default class Area {
	constructor( area ) {
		this.area = area;
	}

	static from_mm2( area ) {
		return new Area( area );
	}

	static from_cm2( centimeters_squared ) {
		return new Area( centimeters_squared * 100 );
	}

	static from_m2( meters_squared ) {
		return new Area( meters_squared * 1000000 );
	}

	static fromDimensions( length, width ) {
		return new Area( length.in_mm() * width.in_mm() );
	}

	in_m2() {
		return this.area / 1000000;
	}

	in_cm2() {
		return this.area / 100;
	}

	in_mm2() {
		return this.area;
	}

	add( area ) {
		return new Area( this.in_mm2() + area.in_mm2() );
	}

}
